module.exports = __webpack_public_path__ + "img/add_value.fdb93659.jpg";